import { render, staticRenderFns } from "./reportedocente.vue?vue&type=template&id=237d577d"
import script from "./reportedocente.vue?vue&type=script&lang=js"
export * from "./reportedocente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports